import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import classes from "./SDGDetail.module.css";
import { BaseURL } from "../home/BaseData";

const SDGDetail = () => {
  const { identifier } = useParams();
  const { i18n } = useTranslation();
  const [goal, setGoal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchGoalDetail = async () => {
      setLoading(true);
      setError(false);
      try {
        const urlsToTry = [
          `${BaseURL.replace(/\/$/, "")}/api/sdg/${identifier}/`,
          `http://127.0.0.1:8001/api/sdg/${identifier}/`,
          `http://127.0.0.1:8000/api/sdg/${identifier}/`,
          `http://localhost:8000/api/sdg/${identifier}/`,
          `http://localhost:8001/api/sdg/${identifier}/`
        ];
        let response = null;
        for (const url of urlsToTry) {
          try {
            response = await axios.get(url);
            if (response && response.data && response.data.goal) break;
          } catch (e) {
            // try next
          }
        }

        if (response && response.data && response.data.goal) {
          setGoal(response.data.goal);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("Error fetching SDG detail:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (identifier) {
      fetchGoalDetail();
    }
  }, [identifier]);

  const lang = i18n.language || "uz";

  const getLocalizedField = (obj, fieldPrefix) => {
    if (!obj) return "";
    return obj[`${fieldPrefix}_${lang}`] || obj[`${fieldPrefix}_uz`] || "";
  };

  if (loading) {
    return <div className={classes.loading}>Yuklanmoqda...</div>;
  }

  if (error || !goal) {
    return (
      <div className={classes.container}>
        <div className={classes.errorBox}>
          <h2 className={classes.errorTitle}>Ma'lumot topilmadi</h2>
          <p>Siz qidirayotgan SDG maqsadi mavjud emas yoki o'chirilgan.</p>
        </div>
      </div>
    );
  }

  const contentHeading = getLocalizedField(goal, "content_heading") || getLocalizedField(goal, "header_title") || getLocalizedField(goal, "title");
  const content = getLocalizedField(goal, "content");
  const author = getLocalizedField(goal, "author");
  const publishDate = goal.publish_date;

  return (
    <div className={classes.container}>
      {/* Main Content Section */}
      <div className={classes.contentWrapper}>
        {contentHeading && (
          <h2 className={classes.contentHeading}>{contentHeading}</h2>
        )}

        <div
          className={classes.richContent}
          dangerouslySetInnerHTML={{ __html: content || "<p>Ma'lumot tez kunda joylanadi.</p>" }}
        />

        {/* Author & Date metadata */}
        {(author || publishDate) && (
          <div className={classes.authorMeta}>
            {author && <p className={classes.authorName}>{author}</p>}
            {publishDate && <p className={classes.publishDate}>{publishDate}</p>}
          </div>
        )}
      </div>
    </div>
  );
};

export default SDGDetail;
